/**
 * Detect self-contained page HTML templates (inline layout + styles).
 * Used so PageViewer matches the editor live preview instead of layering site chrome.
 */

export function isEmbeddedArticlePageHtml(html) {
  if (!html || typeof html !== 'string') return false;
  if (html.includes('<!-- Start of Article Page Content -->')) return true;
  return /\bclass=["'][^"']*\barticle-page\b/.test(html);
}

export function isEmbeddedTunePageHtml(html) {
  if (!html || typeof html !== 'string') return false;
  return html.includes('<!-- Start of Tune Page Content -->');
}
